export default "__VITE_ASSET__Bd$mVKuz__"